export const contactPage = {
  contactUs: 'contactUs',
  callUs: 'callUs',
  email: 'email',
  success: 'success',
  emailNoTCode: 'emailNoTCode',
};

export const chatBotContactTo = {
  email: 'email',
  call: 'call',
};

export const chatBotQueryParams = {
  TOPIC_CODE: 'topic_code',
  TOPIC_KEY: 'topic_key',
};

export const MODAL_TYPE = {
  message: 'message',
  login: 'login',
};

// Top reason for find quick answers
export const suggestTopics = {
  callUs: 'HELPHUB_TOPCONTACTREASON',
};

// Limitation Quick Answer topics numbers
export const limit = {
  quickAnswers: 10,
};

// Quick Answer Layer Name
export const quickAnswerLayer = {
  layer1: 'layer1',
  layer2: 'layer2',
};

export const chatType = {
  chatBot: 'chatBot',
  liveChat: 'liveChat',
};

// Hardcode Email privacy topic ref id
export const privacyRefId = 'PRIV001';

export const modalChannels = {
  chatBot: 'chatBot',
  liveChat: 'liveChat',
  chat: 'chat',
  defaultEmail: 'email',
  finalEmail: 'emailUs',
  call: 'callUs',
  messageUs: 'messageUs',
};

export const stepUpChannels = {
  call: 'callUs',
  email: 'emailUs',
  messageUs: 'messageUs',
  chat: 'chat',
  chatBot: 'chatBot',
  liveChat: 'liveChat',
};

export const emailWebFormTopicRefIds = {
  ipInfringement: 'IPINF001',
};
